import {
  Anchor,
  Container,
  Truck,
  Warehouse,
  FileText,
  Ship,
} from "lucide-react";
import { SERVICES, MEDIA } from "../lib/constants";

const ICONS = { Anchor, Container, Truck, Warehouse, FileText, Ship };

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#0B2545] py-20 md:py-32 overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16 reveal">
          <div className="flex items-center gap-4">
            <span className="gold-line" />
            <h2 className="font-sans text-[#C8A24A] uppercase text-3xl md:text-4xl lg:text-5xl tracking-widest-2 font-semibold">
              What We Do
            </h2>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C8A24A]/20">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Anchor;
            return (
              <article
                key={s.title}
                data-testid={`service-${i}`}
                className="group relative bg-[#0B2545] hover:bg-[#0E2A4D] p-8 md:p-10 transition-colors duration-500 reveal overflow-hidden"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-25 transition-opacity duration-700 pointer-events-none">
                  <img
                    src={MEDIA.services[s.icon]}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B2545] via-[#0B2545]/80 to-transparent" />
                </div>
                <div className="relative">
                  <Icon
                    size={36}
                    strokeWidth={1.4}
                    className="text-[#C8A24A] mb-8"
                  />
                  <h3 className="font-serif text-white text-2xl md:text-[26px] leading-tight mb-4">
                    {s.title}
                  </h3>
                  <p className="font-sans text-white/65 text-sm md:text-[15px] leading-relaxed">
                    {s.body}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
